import axios from 'axios'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*"
axios.defaults.baseURL =  process.env.VUE_APP_API_URL 
const baseURL =  process.env.VUE_APP_API_URL

const actions = {
    async doRequest(state, obj) {
        const url = obj.url? obj.url: "api/proxy/postdata"
        const _this = this
        let USER_TOKEN = await this.getters["authenticator/getToken"]
        let AuthStr = 'Bearer '.concat(USER_TOKEN)
        if (USER_TOKEN) {
            axios.defaults.headers.Authorization = AuthStr
        }
        if (obj && !obj.noLoader) {  this.commit('showLoader', { circle: true }) }
        obj.query.forEach(element => {
            element.clientId = process.env.VUE_APP_CLIENT_ID
        })
        let returnRequestData = await axios.post(url, obj.query, {
            headers: {
                "Content-Type": obj.type? obj.type : "application/json"
            }
            })
            .then(response => {
                if (!obj.noLoader) {
                    _this.commit('hideLoader')
                }
                if (obj.query.docId) {
                    var blob = new Blob([this.response], {type: "application/octet-stream"});
                    var downloadUrl = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    a.href = downloadUrl;
                    a.download = obj.filename;
                    document.body.appendChild(a);
                    a.click();
                    URL.revokeObjectURL(downloadUrl);
                }
                let payload = response && response.data[0] && response.data[0].Payload? response.data[0].Payload : null

                  //Caso queira tratar o erro no retorno da chamada.
                  if (obj.returnError && !payload.success) {
                    let error = payload
                    if (!obj.noLoader) {
                        _this.commit('hideLoader')
                    }
                    return error
                }
                if( payload && !payload.sucesso ) { // && response.data[0].Acao != 'getdetalheslote' && response.data[0].Acao != 'getguias'
                    let paramModal = { }

                    if (payload.error && payload.error.message) {
                        paramModal.message = payload.error.message.trim()
                    } else if (payload.erros && payload.erros.length) {
                        paramModal.message = payload.erros.map(erro => erro.descricao).join(', ')+'.'
                    } else {
                        paramModal.message = 'Contate o administrador do sistema'
                    }

                    paramModal.title = 'Ocorreu erro'
                    paramModal.type = 'error'
                    paramModal.callback = null
                    paramModal.btConfirm = {
                        name: 'Ok',
                        show: true
                    }
                    paramModal.btCancel = {
                        name: 'Cancelar',
                        show: false
                    }
                    _this.commit('hideLoader')
                    _this.commit('confirmMessage/showConfirmMessage', paramModal)
                    return
                }
                return payload
            })
            .catch(error => {
                //Caso queira tratar o erro no retorno da chamada.
                if (obj.returnError) {
                    if (!obj.noLoader) {
                        _this.commit('hideLoader')
                    }
                    return error
                }
                // Erro de autorização, retorna para página de login
                if (error.response && error.response.status == 401) {
                    // TODO: @pantoja
                    //keycloakService.login()
                }
                
                let paramModal = {}
                paramModal.message = error.response &&  error.response.data ? (error.response.data.errors ? Object.values(error.response.data.errors).join('<br>') :
                        (error.response.data.message)) : 'Contate o administrador do sistema'
                paramModal.title = 'Ocorreu erro'
                paramModal.type = 'error'
                paramModal.callback = null
                paramModal.btConfirm = {
                    name: 'Ok',
                    show: true
                }
                paramModal.btCancel = {
                    name: 'Cancelar',
                    show: false
                }
                _this.commit('hideLoader')
                _this.commit('confirmMessage/showConfirmMessage', paramModal)
                
                return error
            })
        
        return returnRequestData
    },
    async sendFile(state, obj) {
        
        const url = "api/proxy/upload"
        const _this = this
        let USER_TOKEN = await this.getters["authenticator/getToken"]
        let AuthStr = 'Bearer '.concat(USER_TOKEN)
        axios.defaults.headers.Authorization = AuthStr
        if (obj && !obj.noLoader) {
            this.commit('showLoader', { circle: true })
        }
        obj.clientId = process.env.VUE_APP_CLIENT_ID
        let returnRequestData = await axios.post(url, obj)
            .then(response => {
                if (!obj.noLoader) {
                    _this.commit('hideLoader')
                }
                let payload = response && response.data[0] && response.data[0].Payload
                if( payload && payload.erros.length) {
                    let paramModal = { }
                    paramModal.message = payload.erros.map(erro => erro.descricao).join('<br>')+'.'
                    paramModal.title = 'Ocorreu erro'
                    paramModal.type = 'error'
                    paramModal.callback = null
                    paramModal.btConfirm = {
                        name: 'Ok',
                        show: true
                    }
                    paramModal.btCancel = {
                        name: 'Cancelar',
                        show: false
                    }
                    _this.commit('hideLoader')
                    _this.commit('confirmMessage/showConfirmMessage', paramModal)
                    return 
                }
                return payload
            })
            .catch(error => {
                //Caso queira tratar o erro no retorno da chamada.
                if (obj.returnError) {
                    if (!obj.noLoader) {
                        _this.commit('hideLoader')
                    }
                    return error
                }
                // Erro de autorização, retorna para página de login
                if (error.response && error.response.status == 401) {
                    // TODO: @pantoja
                    // keycloakService.login()
                }
                
                let paramModal = {}
                paramModal.message = error.response &&  error.response.data ? (error.response.data.errors ? Object.values(error.response.data.errors).join('<br>') :
                (error.response.data.message)) : 'Contate o administrador do sistema'
                // caso venha mensagem tratada no payload, sobrescreve a outra
                let payload = error.response && error.response.data[0] && error.response.data[0].Payload
                if( payload && payload.erros.length) {
                    paramModal.message = payload.erros.map(erro => erro.descricao).join('<br>')+'.'
                }
                //
                paramModal.title = 'Ocorreu erro'
                paramModal.type = 'error'
                paramModal.callback = null
                paramModal.btConfirm = {
                    name: 'Ok',
                    show: true
                }
                paramModal.btCancel = {
                    name: 'Cancelar',
                    show: false
                }
                _this.commit('hideLoader')
                _this.commit('confirmMessage/showConfirmMessage', paramModal)
                return error
            })
        return returnRequestData
    },
    async sendFiles(state, lista) {
        
        let listaResp = []
        const _this = this
        for(let c = 0;c < lista.length; c++){
            let obj = lista[c]
            const url = "api/proxy/upload"
            let USER_TOKEN = await this.getters["authenticator/getToken"]
            let AuthStr = 'Bearer '.concat(USER_TOKEN)
            axios.defaults.headers.Authorization = AuthStr
            if (obj && !obj.noLoader) {
                this.commit('showLoader', { circle: true })
            }
            let returnRequestData = await axios.post(url, obj)
                .then(response => {
                    if (!obj.noLoader) {
                        _this.commit('hideLoader')
                    }
                    let payload = response && response.data[0] && response.data[0].Payload
                    return payload
                })
                .catch(error => {
                    //Caso queira tratar o erro no retorno da chamada.
                    if (obj.returnError) {
                        if (!obj.noLoader) {
                            _this.commit('hideLoader')
                        }
                        return error
                    }
                    // Erro de autorização, retorna para página de login
                    if (error.response && error.response.status == 401) {
                        // TODO: @pantoja
                        // keycloakService.login()
                    }
                    
                    let payload = error.response && error.response.data[0] && error.response.data[0].Payload
                    return payload
                })
            listaResp.push(returnRequestData)
        }
        
        let paramModal = { message: '<ul style="list-style-type: none; font-size: 16px;">'}
        let temErro = false
        let totalErros = 0
        listaResp.forEach(elemento => {

            if(elemento.erros.length){

                let erross = elemento.erros.map(ele => ele.descricao).join(",")
                paramModal.message += `<li> <span style="color:red;">${elemento.nome}</span>: ${erross} </li>`
                temErro = true
                totalErros ++
            }
        })
        paramModal.message += '</ul>'
        if(temErro) {
            paramModal.title = totalErros > 1 ? 'Erros nos seguintes arquivos' : 'Erro no seguinte arquivo'
            paramModal.type = 'warning'
            paramModal.callback = null
            paramModal.btConfirm = {
                name: 'Ok',
                show: true
            }
            paramModal.btCancel = {
                name: 'Cancelar',
                show: false
            }
            
            _this.commit('hideLoader')
            _this.commit('confirmMessage/showConfirmMessage', paramModal)
            let response = {listaResp, sucesso: false}
            return response
        } 
        let response = {listaResp, sucesso: true}
        return response
    },
    async getFile({ commit }, opts) {
        commit('showLoader', { circle: true }, {root: true})
        let obj = {
          url: baseURL + '/api/proxy/download',
          query: opts.query,
          filename: opts.filename
        }
        let USER_TOKEN = await this.getters["authenticator/getToken"]
        let AuthStr = 'Bearer '.concat(USER_TOKEN)
        await new Promise(() => {
          var xhr = new XMLHttpRequest()
          xhr.open('POST', obj.url, true)
          xhr.setRequestHeader('Authorization', AuthStr)
          xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8')
          xhr.responseType = 'blob'
          xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
              var downloadUrl = (window.URL || window.webkitURL).createObjectURL(xhr.response)
              var a = document.createElement("a");
              a.href = downloadUrl;
              a.download = obj.filename
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(downloadUrl);
              setTimeout(()=>commit('hideLoader', null, {root: true}), 1000)
            }
          }
          xhr.onerror = error => {
            let paramModal = {}
            paramModal.message = 'Não foi possível baixar o arquivo, tente novamente mais tarde. Caso o problema persista, contancte o administrador do sistema.'
            paramModal.title = 'Ocorreu erro'
            paramModal.type = 'error'
            paramModal.callback = null
            paramModal.btConfirm = {
              name: 'Ok',
              show: true
            }
            paramModal.btCancel = {
              name: 'Cancelar',
              show: false
            }
            commit('hideLoader', null, {root: true})
            commit('confirmMessage/showConfirmMessage', paramModal)
            return error
          }
          xhr.send(JSON.stringify(obj.query));
        })
      },
    saveTokenInfo(state, obj) {
        let token = obj.token 
        let expires_in = token.expires_in
        sessionStorage.setItem('token', token.access_token)
        sessionStorage.setItem('expireToken', expires_in)
        sessionStorage.setItem('type', token.token_type)
        sessionStorage.setItem('userData', JSON.stringify(obj.userData))
        sessionStorage.setItem('grupoEconomico', obj.userData.grupo_economico)
        sessionStorage.setItem('permissao',  JSON.stringify(obj.userData.Permissao))
        return true
    }
}
export default {
    namespaced: true,
    root: true,
    actions
}